module.exports = __webpack_public_path__ + "assets/img/202111-6.1165c642.png";